import Minze from "minze";
import { MODALS, config } from "../constants";
import { Routing } from "./routing";
import { SearchManager } from "./search";
import { EventEmitter } from "eventemitter3";
import { Locale } from "./locale";

export default class MainModule {
  private static instance: MainModule;
  public static getInstance(): MainModule {
    if (!MainModule.instance) {
      MainModule.instance = new MainModule();
    }
    return MainModule.instance;
  }
  public static setInstance(instance: MainModule): void {
    MainModule.instance = instance;
  }
  private _ee: EventEmitter = new EventEmitter();
  private _lang = "en";
  private _routing: Routing = new Routing();
  private _searchManager = new SearchManager();

  constructor(lang?: string) {
    //TODO: handle construction
    this.initialize(lang || "fr");
  }

  public async initialize(lang: string): Promise<void> {
    //TODO: initialize module

    this._lang = lang;
  }

  public getRouting(): Routing {
    return this._routing;
  }

  public getSearchManager(): SearchManager {
    return this._searchManager;
  }

  public getLang(): any {
    return this._lang;
  }

  public getEE(): EventEmitter {
    return this._ee;
  }

  /* #endregion */

  public showModal(modalId: string): void {
    Minze.cast("tj:toggle-modal", { status: "show", modalId: modalId });
  }

  public hideModal(modalId: string): void {
    Minze.cast("tj:toggle-modal", { status: "hide", modalId: modalId });
  }
  public async fetchData(api: string) {
    const response = await fetch(api);
    return await response.json();
  }
  public isCacheValid(cachedTimestamp: number): boolean {
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - cachedTimestamp;
    return timeDifference < 5 * 60 * 1000; // 5 minutes in milliseconds
  }
  public updateBannerLocalStorage(groupId: string, data: any): void {
    const bannerData = {
      ...data,
      lastDataFetchTime: new Date().getTime(),
    };
    localStorage.setItem(`${groupId}-bannerInfo`, JSON.stringify(bannerData));
  }
  public async loadImportantMessages(groupId: string) {
    const lang = Locale.language;
    let api = "";
    if (groupId === "jeunes") {
      api = `${config.apiRoute}${config.bannerApiRoutes.jeunes}`;
    } else if (groupId === "parents") {
      api = `${config.apiRoute}${config.bannerApiRoutes.parents}`;
    }

    const storedData = localStorage.getItem(`${groupId}-bannerInfo`);
    const lastConfirmedMessage = localStorage.getItem(`${groupId}-bannerLastConfirmedMessage-${lang}`);
    const cachedTimestamp = storedData ? JSON.parse(storedData).lastDataFetchTime : null;

    if (storedData && cachedTimestamp && this.isCacheValid(cachedTimestamp)) {
      const bannerText = JSON.parse(storedData).text[lang];
      if (JSON.parse(storedData).showOnWebsite && bannerText !== lastConfirmedMessage) {
        this.showToastAlert(bannerText, groupId);
        return;
      } else {
        return;
      }
    }

    const data = await this.fetchData(api);
    this.updateBannerLocalStorage(groupId, data);
    if (!storedData || !lastConfirmedMessage || lastConfirmedMessage !== data.text[lang]) {
      if (data.showOnWebsite) {
        this.showToastAlert(data.text[lang], groupId);
      }
    }
  }

  public showToastAlert(message: string, groupId: string) {
    const toast = document.createElement("tj-toast-container");
    toast.setAttribute("data-message", message);
    toast.setAttribute("data-group-id", groupId);
    document.body.insertBefore(toast, document.body.firstChild);
  }

  public getModalIdFromRouting(): MODALS {
    let mainModule = MainModule.getInstance();

    const routeKey = mainModule.getRouting().getRouteKeyFromCurrentLocation();

    switch (routeKey) {
      case "search":
        return MODALS.SEARCH_CONTAINER;
      case "searchResults":
        return MODALS.SEARCH_RESULTS;
      case "youthsSearchResults":
        return MODALS.SEARCH_RESULTS;
      case "parentsSearchResults":
        return MODALS.SEARCH_RESULTS;
      case "newsletter":
        return MODALS.NEWSLETTER;
      case "contactForm":
        return MODALS.CONTACT_FORM;
      case "trainingForm":
        return MODALS.TRAINING_POPUP;
      case "servicesForm":
        return MODALS.SERVICES_FORM;
      case "kitForm":
        return MODALS.KIT_FORM;
      case "popupForm":
        return MODALS.POPUP_FORM;
      case "trainingPopupForm":
        return MODALS.TRAINING_POPUP_FORM;
      case "contactPopupForm":
        return MODALS.CONTACT_POPUP_FORM;
      case "servicesPopupForm":
        return MODALS.SERVICES_POPUP_FORM;
      case "promotionalMaterialForm":
        return MODALS.PROMOTIONAL_MATERIAL_FORM;
      case "podcasts":
        return MODALS.PODCASTS;
      case "cookiesPopup":
        return MODALS.COOKIES_POPUP;
      default:
        return MODALS.NONE;
    }
  }
}
